import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbIconModule, NbButtonModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';

import { MainMenuSidebarComponent } from './main-menu-sidebar.component';
import { UserAccountSidebarModule } from '../user-account-sidebar/user-account-sidebar.module';

@NgModule({
  declarations: [
    MainMenuSidebarComponent
  ],
  imports: [
    CommonModule,
    NbIconModule,
    NbButtonModule,
    TranslateModule,
    UserAccountSidebarModule
  ],
  exports: [
    MainMenuSidebarComponent
  ]
})
export class MainMenuSidebarModule { }
